import React from "react";
import {
  ArticleCardFields,
  CardInternalLink,
  GenericCardFields
} from "../../model/common";
import { RelatedContent } from "../../model/lessons";
import Card from "../Card/Card";
import CardList from "../CardList/CardList";
import { Col, Row } from "../Grid";
import WithSpacing from "../Spacing/Spacing";
import Text from "../Text/Text";
import styles from "./RelatedUnitLessonContent.module.scss";

interface RelatedUnitLessonContentProps {
  relatedContent: RelatedContent;
}

const RelatedUnitLessonContent = ({
  relatedContent
}: RelatedUnitLessonContentProps) => {
  if (!relatedContent.length) {
    return null;
  }
  // Legacy unitOfWork data has > 3 but the template can't cope. Edu team will align over time.
  // individualLesson uses the same type in Sanity, so cap for safety.
  const relatedCapped = relatedContent
    .map(item => ({
      _type: "cardInternalLink",
      reference: item as ArticleCardFields,
      _key: item._id
    }))
    .slice(0, 3);
  return (
    <Row justify="center" className={styles.root}>
      <Col md={10} sm={12}>
        <WithSpacing>
          <Card type="main" className={styles.card}>
            <Text variant="h2">You may also be interested in</Text>
            <CardList
              node={{
                items: relatedCapped as [GenericCardFields | CardInternalLink],
                layout: relatedCapped.length === 3 ? "stretch" : "tile",
                readMore: false
              }}
              widths={[350, 270, 270]}
            />
          </Card>
        </WithSpacing>
      </Col>
    </Row>
  );
};

export default RelatedUnitLessonContent;
